export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10862.d89c0f4c.jpg";